module.exports = __webpack_public_path__ + "img/header-bg.04c35952.png";